import axios from "axios";
import { useLoading } from "../context/axios";
import { handleError } from "../services/notifications";

const ignoredEndpoints = ["/userClients"];
let interceptorRegistered = false; // Flag to prevent multiple registrations

const useAxiosInterceptors = () => {
  const { startLoading, stopLoading } = useLoading();

  if (!interceptorRegistered) {
    axios.interceptors.request.use(
      (config) => {
        const url = new URL(config.url, window.location.origin);
        const pathname = url.pathname;

        if (!ignoredEndpoints.includes(pathname)) {
          startLoading();
        }
        return config;
      },
      (error) => {
        stopLoading();
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        const url = new URL(response.config.url, window.location.origin);
        const pathname = url.pathname;

        if (response.data.status === 0) {
          handleError(response.data);
        }
        if (!ignoredEndpoints.includes(pathname)) {
          stopLoading();
        }
        return response;
      },
      (error) => {
        const url = new URL(error.config.url, window.location.origin);
        const pathname = url.pathname;

        if (error.config && error.config.skipInterceptor) {
          stopLoading();
          return Promise.reject(error);
        }

        if (!ignoredEndpoints.includes(pathname)) {
          stopLoading();
        }
        // Pass the error to handleError function
        handleError(error);

        return Promise.reject(error);
      }
    );

    interceptorRegistered = true; // Set flag to true after registering
  }
};

export default useAxiosInterceptors;
